import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IContent, IContentTableState } from "./ContentTable.types";

const initialState: IContentTableState = {
  contents: [],
  isLoading: false,
  error: null,
};

const contentTableSlice = createSlice({
  name: "contentTable",
  initialState,
  reducers: {
    setContents: (state, action: PayloadAction<IContent[]>) => {
      state.contents = action.payload;
    },
  },
});

export const { setContents } = contentTableSlice.actions;

export default contentTableSlice.reducer;
